export default __webpack_public_path__ + "static/media/bg-infographics.7493625f.webp";